<terra-sticky-footer *ngIf="bankingProviderString">
    Covercy is a financial technology company, not a bank. Banking services provided by {{bankingProviderString}}. 
    <a *ngIf="accountProvider === UnitAccountProvider.Thread" class="link" (click)="openDialog()">Learn more</a>
</terra-sticky-footer>